import Log from 'cgil-log'
export const DEV = process.env.NODE_ENV === 'development'
export const BASE_REST_API_URL = DEV ? 'https://mypodp.lausanne.ch/api' : '/api'
export const BUILD_DATE = '18-07-2023'
export const VERSION = '1.0.10'
export const BASE_PATH = DEV ? '' : ''
export const getLog = (ModuleName, verbosityDev, verbosityProd) =>
  ((DEV) ? new Log(ModuleName, verbosityDev) : new Log(ModuleName, verbosityProd))



// WEBPACK FOOTER //
// ./src/components/config.js